import VeeValidate from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru';
import en from 'vee-validate/dist/locale/en';
import uk from 'vee-validate/dist/locale/uk';
import pl from 'vee-validate/dist/locale/pl';
import locale from "../lang/locale";
import {RU_LANGUAGE, UA_LANGUAGE, PL_LANGUAGE} from "../lang/constants";
import lang from "../lang/translator"

VeeValidate.Validator.localize(
  locale,
  locale.toString() === RU_LANGUAGE ? ru : locale.toString() === UA_LANGUAGE ? uk :  locale.toString() === PL_LANGUAGE ? pl : en
);

function getMessage(key, attr, locale, min, max) {
  console.info(key)
  console.info(attr)
  return lang.get("validation."+key, {attribute: attr, min: min, max: max}, locale);
};

VeeValidate.Validator.localize(
  {
    ru: {
      messages: {
        alpha: (attr) => getMessage('alpha', attr, 'ru'),
        alpha_spaces: (attr) => getMessage('alpha_spaces', attr, 'ru'),
        alpha_dash: (attr) => getMessage('alpha_dash', attr, 'ru'),
        alpha_num: (attr) => getMessage('alpha_num', attr, 'ru'),
      }
    },
    en: {
      messages: {
        alpha: (attr) => getMessage('alpha', attr, 'en'),
        alpha_spaces: (attr) => getMessage('alpha_spaces', attr, 'en'),
        alpha_dash: (attr) => getMessage('alpha_dash', attr, 'en'),
        alpha_num: (attr) => getMessage('alpha_num', attr, 'en'),
      }
    },
    pl: {
      messages: {
        alpha: (attr) => getMessage('alpha', attr, 'pl'),
        alpha_spaces: (attr) => getMessage('alpha_spaces', attr, 'pl'),
        alpha_dash: (attr) => getMessage('alpha_dash', attr, 'pl'),
        alpha_num: (attr) => getMessage('alpha_num', attr, 'pl'),
        min_value: (attr, min) => getMessage('min.numeric', attr, 'pl', min),
        max_value: (attr, max) => getMessage('min.numeric', attr, 'pl', 0, max),
      }
    },
    uk: {
      messages: {
        alpha: (attr) => getMessage('alpha', attr, 'uk'),
        alpha_spaces: (attr) => getMessage('alpha_spaces', attr, 'uk'),
        alpha_dash: (attr) => getMessage('alpha_dash', attr, 'uk'),
        alpha_num: (attr) => getMessage('alpha_num', attr, 'uk'),
      }
    },
  }
);

export default VeeValidate;





// WEBPACK FOOTER //
// ./src/bootstrap/validator.js